export const AS_PLAYER_DEFAULTS = {
    'share': true,
    'tracking': true,

    'debug': false,
    'ads': true,

    'queryParamTimecode': true
};




// WEBPACK FOOTER //
// ./src/player/defaults/ASPlayer.js